import { Icon } from './Icon';

const KEY = 'seohq.theme';

function isDark(): boolean {
  const attr = document.documentElement.getAttribute('data-theme');
  if (attr) return attr === 'dark';
  return window.matchMedia?.('(prefers-color-scheme: dark)').matches ?? false;
}

/** Light / dark switch, as on the reference page. The choice is kept per browser in localStorage `seohq.theme`. */
export function ThemeToggle() {
  return (
    <button
      className="theme-btn"
      type="button"
      aria-label="Switch light or dark"
      title="Switch light or dark"
      onClick={() => {
        const next = isDark() ? 'light' : 'dark';
        document.documentElement.setAttribute('data-theme', next);
        try {
          localStorage.setItem(KEY, next);
        } catch {
          /* storage blocked: the choice lasts until reload */
        }
      }}
    >
      <Icon name="sun" />
    </button>
  );
}
